import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["disabled"]

import { reactive, watchEffect, computed, ref } from 'vue';
	import { Form, Field, ErrorMessage } from 'vee-validate';
	import { Schema } from 'yup';
	import { ServiceType, FormField, DisbursementStatuses } from '@/models/loans';
	import { getMaskingStrategy, formatWithCursorTracking } from '@/composables/maskingUtils';
	import useFormatter from '@/use/formatter';
	import useFunctions from '@/use/functions1';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'DisbursementForm',
  props: {
    onSubmit: { type: Function },
    isSubmitting: { type: Boolean },
    fields: {},
    validationSchema: {},
    mode: {},
    initialValues: {}
  },
  setup(__props: any, { expose: __expose }) {

	const { convertMoneyStringToNumber } = useFunctions();
	const { formatDateInputDisplayValue, formatMoney } = useFormatter();

	const props = __props;

	const formRef = ref<InstanceType<typeof Form> | null>(null);

	const formData = reactive<Record<string, any>>({});

	const initialValuesProp = computed(() => {
		return mapDisbursementObject(props.initialValues)
	});

	const isFormValid = computed(() => {
		return (errors: Partial<Record<string, string | undefined>>) => errors && Object.keys(errors).length === 0;
	});

	function getField(name: string) : FormField | undefined {
		return props.fields.find(f => f.name == name);
	}

	function mapDisbursementObject(selectedDisbursement: any) {
 		const disbursementStatus = getField("disbursementStatusTypeId")?.options?.find((o: ServiceType) => o.id === selectedDisbursement?.disbursementStatusTypeId);
 		const drawDisbursementStatusReasonTypeId =  getField("drawDisbursementStatusReasonTypeId")?.options?.find((o: ServiceType) => o.id === selectedDisbursement?.drawDisbursementStatusReasonTypeId);
		const disbursementDateDisplay = formatDateInputDisplayValue(selectedDisbursement.transactionDate);
		
		return {
			...selectedDisbursement,
			disbursementStatusTypeName: disbursementStatus?.name,
			drawDisbursementStatusReasonTypeName: drawDisbursementStatusReasonTypeId?.name,
			disbursementDateDisplay: disbursementDateDisplay,
		}
	}

	function handleFieldChange(field: FormField, value: any) {
		switch (field.name) 
		{ 
			case "disbursementStatusTypeId": 
				formData.disbursementStatusTypeName = field?.options?.find((o: ServiceType) => o.id === Number(value))?.name;

				if (value === DisbursementStatuses.PreDisbursementCancellation) {
					formData.disbursedAmount = 0;
					formData.disbursedAmountFormatted = formatMoney(0);
				}
				break;
			case "drawDisbursementStatusReasonTypeId":
				formData.drawDisbursementStatusReasonTypeName = field?.options?.find((o: ServiceType) => o.id === Number(value))?.name;
				break;
			case "disbursedAmount":
				if (value === '' || value === null || value === undefined) {
					formData.disbursedAmount = undefined;
					formData.disbursedAmountFormatted = undefined;
				} else {
					formData.disbursedAmountFormatted = formatMoney(typeof value === 'string' ? convertMoneyStringToNumber(value) : value);
				}
				break;
			case "certifiedAmount":
				formData.certifiedAmount = typeof value === 'string' ? convertMoneyStringToNumber(value) : value;
				formData.certifiedAmountFormatted = formatMoney(typeof value === 'string' ? convertMoneyStringToNumber(value) : value);
				break;
			case "transactionDate":
				formData.disbursementDateDisplay = formatDateInputDisplayValue(value);
				break;
			default:
				break;
		}
	}

	function handleInputWithMasking(event: InputEvent, fieldName: keyof typeof formData) {
		const input = event.target as HTMLInputElement;
		formData[fieldName] = formatWithCursorTracking(input);
	}

	function isFieldDisabled(field: FormField) {
		const disabledOnEdit = props.mode === 'edit' && field.disabledOnEdit === true;
		const disabledOnAdd = props.mode === 'add' && field.disabledOnAdd === true;

		return props.mode === 'view' || props.isSubmitting || disabledOnEdit || disabledOnAdd;
	}


	async function onSubmit() {
		if (props.onSubmit) {
			await props.onSubmit({ ...formData });
		}
	}

	watchEffect(() => {
		props.fields.forEach((field) => {
			formData[field.name] = field.value;
			handleFieldChange(field, field.value);
		});
	});

	watchEffect(() => {
		props.fields.forEach((field) => {
			if (field.maskType && formData[field.name] !== undefined) {
				const strategy = getMaskingStrategy(field.maskType);
				const rawValue = String(formData[field.name]);				
				const maskedValue = strategy(rawValue);

				formData[field.name] = maskedValue;
			}
		});
	});

	__expose({
		formData,
		initialValuesProp,
		validate: () => formRef.value?.validate()
	})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    ref_key: "formRef",
    ref: formRef,
    "validation-schema": __props.validationSchema,
    class: "form-container",
    onSubmit: onSubmit
  }, {
    default: _withCtx(({ errors }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
        return (_openBlock(), _createElementBlock("div", {
          key: field.name,
          class: _normalizeClass(['form-input', field.width])
        }, [
          _createElementVNode("label", {
            for: field.name
          }, _toDisplayString(field.label), 9, _hoisted_1),
          (field.type === 'select')
            ? (_openBlock(), _createBlock(_unref(Field), {
                key: 0,
                as: "select",
                id: field.name,
                name: field.name,
                modelValue: formData[field.name],
                "onUpdate:modelValue": [($event: any) => ((formData[field.name]) = $event), ($event: any) => (handleFieldChange(field, $event))],
                disabled: isFieldDisabled(field)
              }, {
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createElementVNode("option", null, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.id,
                      value: option.id
                    }, _toDisplayString(option.name), 9, _hoisted_2))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["id", "name", "modelValue", "onUpdate:modelValue", "disabled"]))
            : (_openBlock(), _createBlock(_unref(Field), {
                key: 1,
                id: field.name,
                name: field.name,
                type: field.type,
                modelValue: formData[field.name],
                "onUpdate:modelValue": [($event: any) => ((formData[field.name]) = $event), ($event: any) => (handleFieldChange(field, $event))],
                disabled: isFieldDisabled(field)
              }, null, 8, ["id", "name", "type", "modelValue", "onUpdate:modelValue", "disabled"])),
          _withDirectives(_createVNode(_unref(ErrorMessage), {
            name: field.name,
            class: "error"
          }, null, 8, ["name"]), [
            [_vShow, __props.mode !== 'view']
          ])
        ], 2))
      }), 128)),
      (__props.mode !== 'view')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "submit-button col-12",
            type: "submit",
            disabled: !isFormValid.value(errors) || __props.isSubmitting
          }, " Submit ", 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}
}

})